// src/services/compensation.service.js
import { api } from './api';

// Get employee compensation details
const getEmployeeCompensation = async (employeeId) => {
    const response = await api.get(
        `/api/compensation/employees/${employeeId}/compensation`
    );
    return response.data;
};

// Update employee compensation
const updateEmployeeCompensation = async (employeeId, compensationData) => {
    const response = await api.put(
        `/api/compensation/employees/${employeeId}/compensation`,
        compensationData
    );
    return response.data;
};

// Get salary component templates
const getSalaryComponentTemplates = async () => {
    const response = await api.get(
        `/api/compensation/salary-component-templates`
    );
    return response.data;
};

const compensationService = {
    getEmployeeCompensation,
    updateEmployeeCompensation,
    getSalaryComponentTemplates,
};

export default compensationService;
